import React from 'react';
import { Link } from 'react-router-dom';
import { getUserRole } from '../services/authService';

function UnauthorizedPage() {
  const userRole = getUserRole();

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      textAlign: 'center'
    }}>
      <h1>Access Denied</h1>
      <p>You don't have permission to access this page.</p>
      <p>Your current role: <strong>{userRole}</strong></p>
      <p>Contact your administrator to get assigned to the appropriate role.</p>
    </div>
  );
}

export default UnauthorizedPage;